<template>
    <div>
        <b-table-lite :items="upsPersonAttributes"/>

        <b-button class="mt-2" block variant="info" v-b-toggle.ups-names-collapse>UPS Names</b-button>
        <b-collapse id="ups-names-collapse">
            <b-table-lite bordered :items="this.upsAttributes.names"/>
        </b-collapse>

        <b-button class="mt-2" block variant="info" v-b-toggle.ups-emails-collapse>UPS Emails</b-button>
        <b-collapse id="ups-emails-collapse">
            <b-table-lite bordered :items="this.upsAttributes.emails"/>
        </b-collapse>

        <b-button class="mt-2" block variant="info" v-b-toggle.ups-addresses-collapse>UPS Addresses</b-button>
        <b-collapse id="ups-addresses-collapse">
            <b-table-lite bordered :items="this.upsAttributes.addresses"/>
        </b-collapse>

        <b-button class="mt-2" block variant="info" v-b-toggle.ups-phones-collapse>UPS Phones</b-button>
        <b-collapse id="ups-phones-collapse">
            <b-table-lite bordered :items="this.upsAttributes.phones"/>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'UpsDetails',
    computed: {
        upsPersonAttributes: function () {
            return Object.entries(
                (({ssn_id, u_id, generate_ssn, formattedSsn, dob, gender_cd, buckley_cd}) => {
                    return {ssn_id, u_id, generate_ssn, formattedSsn, dob, gender_cd, buckley_cd}
                })(this.upsAttributes)
            ).map(([k,v]) => ({attribute: k, value: v}))
        }
    },
    props: {
        upsAttributes: {
            type: Object,
            default: function () {
                return {
                    names: [],
                    emails: [],
                    addresses: [],
                    phones: []
                }
            }
        }
    }
}
</script>